import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faIndustry, faUser, faCalendar, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import useSWR, { mutate } from 'swr';
import AppFooter from '../../components/AppFooter/AppFooter';
import AppHeaderWLF from '../../components/AppHeader/AppHeaderWLF';
import { ProfileStatsWLF } from '../../components/Community/ContestStats/ProfileStatsWLF';
import PopUpSendMessage from '../../components/PopUp/PopUpSendMessage/PopUpSendMessage';
import { ProfileHeaderWLF } from '../../components/Profile/ProfileHeader/ProfileHeaderWLF';

import { useAuth } from '../../context/AuthContext';
import axiosHelper from '../../helpers/axiosHelper';
import { finalSlicedString, registrationDateString } from '../../helpers/utils';
import { getFooterMenu, getHeaderMenu } from '../../store/Selectors';
import { ROUTEPATHS } from '../routePaths';
import ProfileEditable from './SUBPAGES/ProfileEditable';
import ProfileWLF from './SUBPAGES/ProfileWLF';
import AmbassadorWLF from './SUBPAGES/AmbassadorWLF';
import BadgesWLF from './SUBPAGES/BadgesWLF';
import FavoritesWLF from './SUBPAGES/FavoritesWLF';
import PortfolioWLF from './SUBPAGES/PortfolioWLF';
import AwardsWLF from './SUBPAGES/AwardsWLF';
import InspirationsWLF from './SUBPAGES/InspirationsWLF';
import { useParams } from 'react-router-dom';
import { useStoreState } from 'pullstate';
import headerimg from '../../assets/header_placeholder_transparent.png';
import headerLogo from '../../assets/desall_logo.png';
import footerImg from '../../assets/footer_placeholder_transparent.png';

import { clientNavPages, designerNavPages, personalClientNavPages, personalProfileNavPages } from '../../mockdata/navPages';
import { INavLink, User } from '../../global';
import styles from './Profile.module.scss';
import ProfilePicWLF from '../../components/Profile/ProfilePic/ProfilePicWLF';
import ProfileNavigationWLF from '../../components/PageNavigation/PROFILE/ProfileNavigationWLF';
import ContestsWLF from './SUBPAGES/ContestsWLF';
import DesignComponent from '../../components/Design/DesignComponent/DesignComponent';
import LogoAnimation from '../../components/LogoAnimation/LogoAnimation';
import { getPortfolioDesignNames } from '../../store/DesallSelectors';
import DesallStore from '../../store/DesallStore';
import DslStore from '../../store/DslStore';
interface ProfileMainProps {
  isPreview?: boolean;
}

const ProfileMain: React.FC<ProfileMainProps> = ({ isPreview = false }) => {
  let { username } = useParams();
  const { pageName } = useParams();
  const { designName } = useParams();
  const [navPages, setNavPages] = useState<INavLink[]>(designerNavPages);
  const [currentPage, setCurrentPage] = useState<INavLink>(designerNavPages[0]);
  // const [editable, setEditable] = useState(false);
  const headerMenu = useStoreState(DslStore, getHeaderMenu);
  const footerMenu = useStoreState(DslStore, getFooterMenu);
  const designNames = useStoreState(DesallStore, getPortfolioDesignNames);
  const { data, error, isLoading } = useSWR('user|' + username, axiosHelper.usersFetcher);
  const { loggedUser } = useAuth();
  const [messageBanner, setMessageBanner] = useState(0);
  const [successBanner, setSuccessBanner] = useState(0);
  const [popupMessage, setPopupMessage] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const [editable, setEditable] = useState(false);
  const [mine, setMine] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState(`${ROUTEPATHS.COMMUNITY_PROFILE}`);

  useEffect(() => {
    console.log('DATA USEEFFECT');
    if (data) {
      console.log(data);
      setUser(data);
    }
  }, [data]);

  useEffect(() => {
    setEditable(false);
    setMine(false);
    if (user) {
      if (user.userType === 'D') {
        setNavPages(designerNavPages);
      } else if (user.userType === 'C') {
        setNavPages(clientNavPages);
      } else if (user.userType === 'G') {
        setNavPages(designerNavPages);
      }
    }

    if (loggedUser && user) {
      if (loggedUser.id === user.id) {
        setMine(true);
        if (!isPreview) {
          setEditable(true);
        }
        if (user.userType === 'D') {
          setNavPages(personalProfileNavPages);
        } else if (user.userType === 'C') {
          setNavPages(personalClientNavPages);
        }
      }
    }
  }, [loggedUser, user, isPreview]);

  useEffect(() => {
    const pageForName = (name: string) => {
      return navPages.find((item) => item.path === `/${name}`);
    };

    if (!pageName) {
      setCurrentPage(navPages[0]);
      return;
    }
    const page = pageForName(pageName);
    if (page) {
      setCurrentPage(page);
    } else {
      setCurrentPage(navPages[0]);
    }
  }, [pageName, navPages]);

  const userChanged = (updatedUser: User) => {
    console.log('USER CHANGED');
    mutate('user|' + username, updatedUser, { revalidate: false }); // Update localStorage cache
    setUser(updatedUser);
  };

  return (
    <>
      <div className="bg-light-gray">
        <AppHeaderWLF
          links={headerMenu}
          bgColor="#eab95a"
          logoImg={headerLogo}
          bgImage={headerimg}
          alpha={0.4}
          breadcrumbs={`Home/Community`}
          pageTitle={username}
          hideSearch={true}
        />
        {isLoading ? (
          <LogoAnimation />
        ) : (
          <>
            {user && <ProfileNavigationWLF user={user} links={navPages} currentPage={currentPage} />}

            <main className={`${styles.profileWrapper} container  px-md-3 pt-5  px-sm-0 `}>
              {user && (
                <>
                  {!designName && (
                    <>
                      {currentPage.id === 0 && (
                        <div className="row ">
                          <div className="col-12 px-md-2 mx-md-1 pe-md-3   ">
                            <ProfileHeaderWLF editable={editable && currentPage.id === 0} user={user} />
                          </div>
                        </div>
                      )}
                      <div className={`row px-4   mt-3 px-sm-0  `}>
                        <div className="col-3 "></div>
                        <div className="col-md-9 d-sm-none d-md-block">
                          <h1 className="bigger-text-bold ms-4 color-blue">{finalSlicedString(user.username)}</h1>
                          <div className="sub-title-editable ms-4 color-dark text-capitalize">{user.userType === 'D' ? user.job?.name : user?.sector}</div>
                        </div>
                        <div
                          className={`col-12 col-md-3 d-sm-flex align-items-sm-center justify-content-sm-center text-center position-relative ps-md-3 ${styles.profilePic} ${
                            user.bannerAttachment && currentPage.id === 0 ? styles.picUp : styles.minipicUp
                          } `}
                        >
                          <ProfilePicWLF editable={editable && currentPage.id === 0} user={user} />
                        </div>
                        <div className="col-12 d-md-none  d-flex mt-10 justify-content-center">
                          <div className="text-center">
                            <h1 className="bigger-text-bold ms-4 color-blue">{finalSlicedString(user.username)}</h1>
                            <div className="sub-title-editable ms-4 color-dark text-capitalize">{user.userType === 'D' ? user.job?.name : user.sector}</div>
                          </div>
                        </div>

                        <div className="col-12 col-md-3 mb-lg-3 ">
                          <div className="info ms-4   d-flex flex-column-reverse align-items-center h-100  ">
                            <div className=" d-flex flex-row align-items-center  justify-content-center col-12 mb-lg-5 mb-md-4 mb-3 ">
                              <div className="me-2  d-flex flex-row align-items-center">
                                {user.userType === 'C' ? (
                                  <FontAwesomeIcon icon={faIndustry as IconProp} className=" text color-blue " />
                                ) : (
                                  <FontAwesomeIcon icon={faUser as IconProp} className=" text color-blue me-0" />
                                )}
                              </div>
                              <div className="text  col-11">{user?.userType === 'C' ? 'Company' : 'User'}</div>
                            </div>
                            <div className=" d-flex flex-row align-items-center  justify-content-center col-12 mb-lg-3 mb-md-4 mb-3  ">
                              <div className="me-2  d-flex flex-row align-items-center">
                                <FontAwesomeIcon icon={faCalendar as IconProp} className=" text color-blue " />
                              </div>
                              <div className="text col-11 ">since {registrationDateString(user.registrationDate)}</div>
                            </div>
                            <div className=" d-flex flex-row align-items-center  justify-content-center col-12 mb-lg-3 mb-md-4  mb-3">
                              {user.visibleLocation && (
                                <>
                                  <div className="me-2  d-flex flex-row align-items-center">
                                    <FontAwesomeIcon icon={faMapMarkerAlt as IconProp} className=" text color-blue " />
                                  </div>

                                  <div className="text col-11">{user.visibleLocation}</div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6  pt-4  ">
                          <ProfileStatsWLF user={user} />
                        </div>
                      </div>
                      {popupMessage && (
                        <>
                          <PopUpSendMessage
                            popup={popupMessage}
                            close={() => setPopupMessage(false)}
                            setMessageNumber={(message) => (setMessageBanner(message), setPopupMessage(false))}
                            recipient={user.username}
                          />
                        </>
                      )}
                    </>
                  )}
                  {currentPage.id === 0 && (
                    <>
                      {editable ? (
                        <ProfileEditable user={user} callback={userChanged} successBanner={(n) => setSuccessBanner(n)} />
                      ) : (
                        <ProfileWLF user={user} loggedUser={loggedUser} setBreadcrumbs={setBreadcrumbs} setPopupMessage={setPopupMessage} />
                      )}
                    </>
                  )}
                  {currentPage.id === 1 && designName && (
                    <DesignComponent userNameForURL={user.nameForURL} designName={designName} loggedUser={loggedUser} designNames={designNames} />
                  )}
                  {currentPage.id === 1 && !designName && <PortfolioWLF user={user} loggedUser={loggedUser} breadcrumbs={setBreadcrumbs} />}
                  {currentPage.id === 10 && <AmbassadorWLF user={user} loggedUser={loggedUser!} breadcrumbs={setBreadcrumbs} />}
                  {currentPage.id === 12 && <ContestsWLF user={user} loggedUser={loggedUser} breadcrumbs={setBreadcrumbs} />}

                  {currentPage.id === 2 && <InspirationsWLF user={user} loggedUser={loggedUser} breadcrumbs={setBreadcrumbs} />}
                  {currentPage.id === 3 && <FavoritesWLF user={user} loggedUser={loggedUser} breadcrumbs={setBreadcrumbs} />}
                  {currentPage.id === 4 && <BadgesWLF user={user} loggedUser={loggedUser} breadcrumbs={setBreadcrumbs} setPopupMessage={setPopupMessage} />}
                  {currentPage.id === 5 && <AwardsWLF user={user} loggedUser={loggedUser} breadcrumbs={setBreadcrumbs} setPopupMessage={setPopupMessage} />}
                </>
              )}
            </main>
          </>
        )}
        <AppFooter links={footerMenu} bgColor="#304053" logoImg={headerLogo} bgImage={footerImg} />
      </div>
    </>
  );
};

export default ProfileMain;
